export const DEFAULT_TIMEOUT: number = 7 * 1000; // 7s timeout, typical GIC load is ~3s
export const MAX_ERROR_IMAGE_WIDTH = 188;
export const MAX_ERROR_IMAGE_HEIGHT = 250;
